var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('layout-header'),_c('layout-body'),_c('layout-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }